import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  totalQuantity: number;
  totalAmount: number;
  ty_gia?: number;
}

export default function BottomBar({ totalQuantity, totalAmount }: BottomBarProps) {
  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[180px]',
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: totalQuantity, precision: 6 }]
    },
    {
      className: 'min-w-[240px]',
      fields: [{ name: 't_tien_nt', label: 'Tổng tiền', value: totalAmount, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}
